import React, { useCallback, useEffect, useState } from 'react';
import { MdOutlineMoreVert } from 'react-icons/md';
import { usePopper } from 'react-popper';
import { IEvent } from 'types';
import * as styles from './volunteerActionMenu.style';

export interface VolunteerActionMenuItem {
  label: string;
  onClick: () => void;
  visible: boolean;
  disabled?: boolean;
}

interface Props {
  event?: IEvent;
  items: VolunteerActionMenuItem[];
}

function VolunteerActionMenu({ items }: Props) {
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { styles: popperStyles, attributes } = usePopper(
    referenceElement,
    popperElement,
    { placement: 'bottom-end' },
  );

  const [isOpen, setIsOpen] = useState(false);
  const handleOff = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    window.document.addEventListener('click', handleOff);
    return () => window.document.removeEventListener('click', handleOff);
  }, [handleOff]);

  const visibleItems = items.filter((item) => item.visible);
  if (visibleItems.length === 0) return null;

  return (
    <div css={styles.wrap}>
      <div
        ref={setReferenceElement}
        css={styles.trigger}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <MdOutlineMoreVert size={24} />
      </div>
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          ref={setPopperElement}
          style={popperStyles.popper}
          {...attributes.popper}
          css={styles.menu}
        >
          <ul css={styles.list}>
            {visibleItems.map((item) => (
              <li
                key={item.label}
                css={styles.item(!!item.disabled)}
                onClick={() => {
                  if (item.disabled) return;
                  setIsOpen(false);
                  item.onClick();
                }}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default VolunteerActionMenu;
